import type { EntityComponent } from "../world/components";
import type { EntityKind } from "../world/Entity";
import { EntityDefinitionRegistry, type EntityDefinitionEntry } from "./EntityDefinitionRegistry";

export class EntityDefinitionContentError extends Error {}

/** Builds the entity definition registry from an array of parsed JSON files. */
export function loadEntityDefinitionRegistry(entries: unknown[]): EntityDefinitionRegistry {
  const registry = new EntityDefinitionRegistry();
  for (const raw of entries) {
    const definition = parseEntityDefinitionEntry(raw);
    registry.register(definition);
  }
  return registry;
}

function parseEntityDefinitionEntry(raw: unknown): EntityDefinitionEntry {
  if (typeof raw !== "object" || raw === null) {
    throw new EntityDefinitionContentError("Entity definition must be an object");
  }
  const d = raw as Record<string, unknown>;
  if (typeof d["definitionId"] !== "string" || d["definitionId"].length === 0) {
    throw new EntityDefinitionContentError("Entity definition missing definitionId");
  }
  if (typeof d["kind"] !== "string") {
    throw new EntityDefinitionContentError(`Entity definition "${d["definitionId"]}" missing kind`);
  }
  if (typeof d["asset"] !== "string") {
    throw new EntityDefinitionContentError(`Entity definition "${d["definitionId"]}" missing asset`);
  }
  const size = d["size"] as { width?: unknown; height?: unknown } | undefined;
  if (!size || typeof size.width !== "number" || typeof size.height !== "number") {
    throw new EntityDefinitionContentError(`Entity definition "${d["definitionId"]}" missing numeric size.width/size.height`);
  }
  const components = Array.isArray(d["components"]) ? (d["components"] as EntityComponent[]) : [];
  return {
    definitionId: d["definitionId"],
    kind: d["kind"] as EntityKind,
    asset: d["asset"],
    size: { width: size.width, height: size.height },
    components,
  };
}
